import * as React from "react";
import {
  ActivityFragment,
  ContractMinimalFragment,
  MadMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { ContractIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { P, Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type ContractCreatedActivity = ActivityFragment & {
  recipient: MadMinimalFragment;
  trackable: ContractMinimalFragment;
};

export function isContractCreatedActivity(
  q: ActivityFragment
): q is ContractCreatedActivity {
  return q.key === "contract.created";
}

interface ContractCreatedActivityProps {
  activity: ContractCreatedActivity;
}

//FIXME get link for contract PDF
export const ContractCreatedActivity: React.FC<ContractCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="contractCreatedActivity"
      visual={<ContractIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.contractCreated", {
          contract: (
            <Link to={`/contracts/${activity.trackable.id}`} key={activity.id}>
              {t("activity.objects.contract")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
